import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.fund.item');
import { OnInit, Input, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-fund-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.fund.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminFundItemComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund_id: any;
    @Input() menu: any;
    @Input() sub: any;

    public fund: any = null;
    public investments: any = [];
    public operationDraft: any = null;
    public financialDraft: any = null;
    public savingDraft: boolean = false;

    private ready: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.ready = true;
    }

    public async ngOnChanges(changes: any) {
        if (!this.ready) return;
        if (changes.fund_id) {
            await this.load();
            return;
        }
        if (changes.menu) {
            await this.prepareMenu();
        }
    }

    public async load() {
        if (this.fund_id == "new") {
            this.fund = this.emptyFund();
            this.investments = [];
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("info", { id: this.fund_id });
        this.fund = data.info;
        this.investments = data.investments;
        await this.prepareMenu();
        await this.service.render();
    }

    private emptyFund() {
        return {
            id: 'new',
            name: '',
            investment_status: '결성',
            investment_stage: '참여신청',
            payment_method: '일시납',
            investment_resource: '민간',
            type: '개투',
            category: '블라인드',
            mgmt_rate: Array.from({ length: 8 }, () => ({ base: '결성총액', rate: '' })),
            base_rate: { type: 'IRR', value: '' },
            extra: {
                fund_info: '',
                gps: [],
                key_staff_list: [],
                managers: [],
                mgmt_frequency: 'annual',
                account_name: ''
            },
            visibility: {},
            isnew: true
        };
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public linkFundMenu(menu: string) {
        return `/admin/invest/fund/${this.sub}/${this.fund_id}/${menu}`;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    private async prepareMenu() {
        if (!this.fund || this.fund_id == "new") return;
        if (this.menu == "operation-report-write") {
            await this.loadOperationDraft(false);
        }
        if (this.menu == "financial-statement-write") {
            await this.loadFinancialDraft(false);
        }
    }

    public async loadOperationDraft(force: boolean = true) {
        if (!force && this.operationDraft) return;

        const period = this.operationDraft?.period || "";
        this.operationDraft = { loading: true };
        await this.service.render();

        const { code, data } = await wiz.call("operation_report_draft", {
            id: this.fund_id,
            period: period
        });
        if (code != 200) {
            this.operationDraft = null;
            await this.alert("조합운용보고서 초안을 생성하지 못했습니다.");
            return;
        }

        this.operationDraft = data.draft || {};
        this.operationDraft.status = this.operationDraft.status || "draft";
        await this.service.render();
    }

    public async loadFinancialDraft(force: boolean = true) {
        if (!force && this.financialDraft) return;

        const period = this.financialDraft?.period || "";
        this.financialDraft = { loading: true };
        await this.service.render();

        const { code, data } = await wiz.call("financial_statement_draft", {
            id: this.fund_id,
            period: period
        });
        if (code != 200) {
            this.financialDraft = null;
            await this.alert("재무제표 초안을 생성하지 못했습니다.");
            return;
        }

        this.financialDraft = data.draft || {};
        this.financialDraft.status = this.financialDraft.status || "draft";
        if (!this.financialDraft.other_expenses) {
            this.financialDraft.other_expenses = [];
        }
        await this.service.render();
    }

    private toNumber(value: any): number {
        if (value === null || value === undefined || value === "") return 0;
        if (typeof value === "string") {
            value = value.replace(/,/g, "").replace(/원/g, "").trim();
        }
        const num = Number(value);
        if (Number.isNaN(num)) return 0;
        return num;
    }

    public formatCurrency(value: any): string {
        return `${Math.round(this.toNumber(value)).toLocaleString("ko-KR")}원`;
    }

    public otherExpenseTotal(): number {
        if (!this.financialDraft || !this.financialDraft.other_expenses) return 0;
        return this.financialDraft.other_expenses.reduce((sum: number, row: any) => {
            return sum + this.toNumber(row.amount);
        }, 0);
    }

    public financialTotals() {
        const d = this.financialDraft || {};
        const totalIncome = this.toNumber(d.investment_income) + this.toNumber(d.interest_income) + this.toNumber(d.other_income);
        const totalExpense = this.toNumber(d.management_fee) + this.otherExpenseTotal();
        const netIncome = totalIncome - totalExpense;
        const assetTotal = this.toNumber(d.cash) + this.toNumber(d.investment_assets) + this.toNumber(d.other_assets);
        const equityTotal = this.toNumber(d.contributed_capital) + netIncome;
        return {
            totalIncome,
            totalExpense,
            netIncome,
            assetTotal,
            liabilitiesEquityTotal: this.toNumber(d.liabilities) + equityTotal
        };
    }

    public addOtherExpense() {
        if (!this.financialDraft.other_expenses) this.financialDraft.other_expenses = [];
        this.financialDraft.other_expenses.push({ label: "기타 비용", amount: 0 });
        this.service.render();
    }

    public removeOtherExpense(index: number) {
        if (!this.financialDraft.other_expenses) return;
        this.financialDraft.other_expenses.splice(index, 1);
        this.service.render();
    }

    public async renderFinancialStatement() {
        if (!this.financialDraft) return;
        const { code, data } = await wiz.call("render_financial_statement", {
            id: this.fund_id,
            data: JSON.stringify(this.financialDraft)
        });
        if (code != 200) {
            await this.alert("재무제표 본문을 갱신하지 못했습니다.");
            return;
        }
        this.financialDraft.content = data.content;
        await this.service.render();
    }

    public async saveGeneratedReport(type: string) {
        const draft = type == "financial" ? this.financialDraft : this.operationDraft;
        if (!draft || !draft.title || !draft.content) {
            await this.alert("저장할 초안 내용이 없습니다.");
            return;
        }

        this.savingDraft = true;
        await this.service.render();

        const { code } = await wiz.call("save_generated_report", {
            id: this.fund_id,
            title: draft.title,
            content: draft.content,
            status: draft.status || "draft",
            report_type: type
        });

        this.savingDraft = false;

        if (code != 200) {
            await this.alert("보고서 저장에 실패했습니다.");
            await this.service.render();
            return;
        }

        await this.alert("조합운용보고 목록에 저장되었습니다.", "success");
        await this.service.render();
    }
}

export default PortalLpsysadminFundItemComponent;